import React from "react";
import { Container, Carousel } from "react-bootstrap";
import "../../App.css";

function SolidEdge() {
  return (
    <Container style={{ maxWidth: "60%" }}>
      <div className="row">
        <p></p>
        <h1> Siemens Solid Edge </h1>
        <p></p>
        <p></p>
        <div className="col">
          <h5>
            {" "}
            <b>Schulungsthemen </b>
          </h5>
          <ul>
            <li>Basis-Schulung</li>
            <li>Aufbau-Schulung</li>
            <li>Freiformflächen</li>
            <li>Synchrone Konstruktion</li>
            <li>Update-Schulungen</li>
            <li>Blech-Konstruktion</li>
          </ul>
          <h5>Weitere Spezialthemen auf Anfrage</h5>
        </div>
        <div className="col">
          <h5>
            Beispiel:{" "}
            <i>Curriculum Aufbauschulung für Weiterbildungsinstitut</i>
          </h5>
          <Carousel interval={null}>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="/se-schulung/seite1.png"
                alt="Seite 1"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="/se-schulung/seite2.png"
                alt="Seite 2"
              />
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
      <div class="spacer"></div>
    </Container>
  );
}

export default SolidEdge;
